import React from "react";
import { Button } from "react-bootstrap";
import { FaSkull } from "react-icons/fa";

import * as api from "../../api/api";
import SlideToUnlock from "../../components/SlideToUnlock";

export default function EmergencyLandSlider(props) {
    const [isEmergencyLanding, setIsEmergencyLanding] = React.useState(false);

    function thisDroneIsFlying() {
        if (!props.drone) return false;
        if (!props.droneState) return false;
        if (!props.droneState.widgets) return false;

        return api.droneIsFlying(props.droneState.widgets);
    }

    // biome-ignore lint/correctness/useExhaustiveDependencies: Reset when the drone inputs change; the helper is a pure read of those inputs and is recreated on every render.
    React.useEffect(() => {
        // Reset state when drone stops flying
        if (!thisDroneIsFlying()) {
            setIsEmergencyLanding(false);
        }
    }, [props.drone, props.droneState]);

    return (
        thisDroneIsFlying() && (
            <div className="d-flex justify-content-center">
                {isEmergencyLanding ? (
                    <Button
                        variant="danger"
                        className="mt-2 btn-sm"
                        onClick={(e) => {
                            api.sendKill(
                                props.drone.id,
                                props.droneState.missions,
                            );
                            e.stopPropagation();
                        }}
                    >
                        <FaSkull className="me-2" />
                        Kill
                    </Button>
                ) : (
                    <SlideToUnlock
                        onUnlock={function unlock() {
                            api.sendEmergencyLand(
                                props.drone.id,
                                props.droneState.missions,
                            );
                            setIsEmergencyLanding(true);
                        }}
                        small={props.small}
                        display="Slide to land >>"
                    />
                )}
            </div>
        )
    );
}
